import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  style: {"font-size":"150%"}
}
const _hoisted_3 = {
  key: 0,
  class: "host-running"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "attached-client"
}
const _hoisted_6 = {
  key: 1,
  class: "no-attached-client"
}
const _hoisted_7 = {
  key: 2,
  class: "host-not-running"
}
const _hoisted_8 = {
  key: 1,
  style: {"font-size":"150%"}
}
const _hoisted_9 = { class: "error" }
const _hoisted_10 = ["disabled"]

import { ref, computed, watch, onMounted } from "vue";

interface ApiData {
  host_name: string;
  no_machine_running: boolean;
  client_attached: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Status',
  setup(__props) {

const hostName = ref(localStorage.getItem("hostName") ?? "");
const initialized = ref(false);
const connected = ref(true);
const isRunning = ref(false);
const hasClient = ref(false);
const loading = ref(false);
const timerHandle = ref(-1);

watch(hostName, (newValue: string) => {
  if (newValue) {
    localStorage.setItem("hostName", newValue);
  } else {
    localStorage.removeItem("hostName");
  }
  document.title = `${newValue} NoMachine status`;
});

const apiAddress = computed((): string => {
  if (hostName.value) {
    if (hostName.value.includes("//")) {
      return `${hostName.value}/api`;
    } else {
      return `//${hostName.value}/api`;
    }
  } else {
    return "./api";
  }
});

function getStatus() {
  try {
    loading.value = true;
    fetch(apiAddress.value)
      .then((response) => {
        if (response.ok) {
          response.json().then((data: ApiData) => {
            connected.value = true;
            if (!hostName.value) {
              hostName.value = data.host_name;
            }
            isRunning.value = data.no_machine_running;
            hasClient.value = data.client_attached;
          });
        }
      })
      .catch(() => {
        connected.value = false;
      })
      .finally(() => {
        initialized.value = true;
        loading.value = false;
        setUpTimer();
      });
  } catch (err) {
    initialized.value = true;
    loading.value = false;
    connected.value = false;
    setUpTimer();
  }
}

function refreshClick() {
  clearTimer();
  getStatus();
}

function clearTimer() {
  window.clearTimeout(timerHandle.value);
  timerHandle.value = -1;
}

function setUpTimer() {
  timerHandle.value = window.setTimeout(getStatus, 15000);
}

function settingsClick() {
  const newHostName = window.prompt(
    "Enter hostname, with optional leading http:// or https:// and optional port",
    hostName.value
  );
  if (newHostName != null && newHostName != hostName.value) {
    const useNewHostname = window.confirm(
      `Use "${newHostName}" instead of "${hostName.value}"?`
    );
    if (useNewHostname) {
      hostName.value = newHostName ?? "";
      refreshClick();
    }
  }
}

onMounted(() => {
  getStatus();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", {
      class: _normalizeClass({ error: !connected.value, header: true })
    }, [
      _cache[1] || (_cache[1] = _createElementVNode("div", null, " ", -1)),
      _createElementVNode("div", null, [
        _createTextVNode(" NoMachine status on " + _toDisplayString(hostName.value) + ": ", 1),
        _createElementVNode("span", {
          class: _normalizeClass({ hidden: !loading.value })
        }, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("img", {
            src: "Spinner-1s-200px.svg",
            alt: "loading",
            class: "loading-spinner"
          }, null, -1)
        ]))], 2)
      ]),
      _createElementVNode("div", {
        class: "setup-gear",
        onClick: settingsClick,
        tabindex: "0"
      }, "⚙️")
    ], 2),
    (initialized.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (connected.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (isRunning.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, " NoMachine host process is running. "))
                  : _createCommentVNode("", true),
                (isRunning.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (hasClient.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " A client IS attached -- use caution when connecting "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_6, " No client is attached -- free to connect "))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, " NoMachine host process is NOT running. "))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, "Can't get status from " + _toDisplayString(hostName.value), 1)
              ]))
        ]))
      : _createCommentVNode("", true),
    (initialized.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          disabled: loading.value,
          class: "refresh-button",
          onClick: refreshClick
        }, " Refresh ", 8, _hoisted_10))
      : _createCommentVNode("", true)
  ]))
}
}

})